<!-- Translated: yes -->
<template>
  <span>
    <span :class="'price'" v-if="!isDiscounted">
      {{priceOriginal | currency }}
    </span>
    <span :class="'price price--discounted'" v-if="isDiscounted">
      <span class="price--original">{{ priceOriginal | currency}}</span><br />
      <span class="price--discounted">{{ priceDiscounted | currency}}</span>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    product: {
    },
    price: {
    },
    discounted: {
    },
  },
  data() {
    return {
      price_original: 0,
      price_discounted: null,
    };
  },
  computed: {
    isDiscounted() {
      return this.priceOriginal !== this.priceDiscounted;
    },
    priceOriginal() {
      if (this.product) {
        return this.product.price_per_piece * this.product.quantity;
      }

      return this.price;
    },
    priceDiscounted() {
      let discounted = this.priceOriginal;

      if (this.product) {
        if (Number.isInteger(this.product.discounted_price_per_piece)) {
          discounted = this.product.discounted_price_per_piece * this.product.quantity;
        } else {
          return this.priceOriginal;
        }
      } else {
        console.log(this.discounted);
        discounted = this.discounted;
      }

      if (discounted < 0) {
        return this.priceOriginal;
      }

      if (isNaN(discounted)) {
        return this.priceOriginal;
      }

      return discounted;
    },
  },
  mounted() {
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.price
  &.price--discounted
    line-height 1.2em
    .price--original
      text-decoration line-through
      margin-right 0
      opacity 0.5
    .price--discounted
      color red
</style>



// WEBPACK FOOTER //
// PriceView.vue?bd46bf2c